module.exports = __webpack_public_path__ + "img/c06_unitstartechtotalwar_Normal_ua.efdc52b0.webp";